/**
 * Auth API - all auth-related requests. Uses shared api instance and central endpoints.
 */
import api from '../utils/api';
import { ENDPOINTS } from '../config/endpoints';

const { AUTH } = ENDPOINTS;

export const qrLogin = (mirrorId) =>
  api.post(AUTH.QR_LOGIN, { mirrorId });

/** MSG91 widget: send OTP. Pass 10-digit mobile; backend adds country code. */
export const sendOtp = (mobile) =>
  api.post(AUTH.SEND_OTP, { mobile });

/** MSG91 verify + app login (JWT + mirror session). */
export const verifyOtp = (reqId, otp, mobile, mirrorId, qrToken) =>
  api.post(AUTH.VERIFY_OTP, { reqId, otp, mobile, mirrorId, qrToken });

export const completeProfile = (formData) =>
  api.post(AUTH.COMPLETE_PROFILE, formData);

export const adminLogin = (email, password) =>
  api.post(AUTH.ADMIN_LOGIN, { email, password });

/** Check if mirror has an active session (e.g. TV has claimed it). Do not consume. */
export const getMirrorSession = (mirrorId) =>
  api.get(AUTH.mirrorSession(mirrorId, false));

export const consumeMirrorSession = (mirrorId) =>
  api.get(AUTH.mirrorSession(mirrorId, true));

/** First-time signup: tell the mirror TV to open the dashboard after Start My Session. */
export const startTvSession = (mirrorId) =>
  api.post(AUTH.startTvSession(mirrorId));
